import { render, staticRenderFns } from "./TxInfo.vue?vue&type=template&id=46597196&scoped=true&"
import script from "./TxInfo.vue?vue&type=script&lang=js&"
export * from "./TxInfo.vue?vue&type=script&lang=js&"
import style0 from "./TxInfo.vue?vue&type=style&index=0&id=46597196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46597196",
  null
  
)

export default component.exports